export default __webpack_public_path__ + "static/media/MyPicture.402dd54b.png";